module.exports = __webpack_public_path__ + "img/tech 1.c8e47b07.png";